const data = {
    table: {
        columns: [
            {title: '类别', field: 'cat', width: '180'},
            {title: '项目名称', field: 'name', width: '200'},
            {title: '医生级别', field: 'doctor', width: '180'},
            {title: '项目意义', field: 'content', width: ''},
            {title: '价格(元)', field: 'fee', width: '120'},
        ],
        data: [],
        total: 0,
        page: 1,
        pageSize: 10
    },
}

export default data
